import { render } from "./App.vue?vue&type=template&id=0b2ef887"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0b2ef887&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__